'use client';

import { InverseHeader } from '@jouzen/ecom-components/layout';

import ProductBreakthrough from '@/app/components/LegacyLandingPage/components/ProductBreakthrough';

import GiftCallToAction from './_components/GiftCallToAction';
import GiftHero from './_components/GiftHero';
import GiftMarquee from './_components/GiftMarquee';
import GiftTestimonials from './_components/GiftTestimonials';
import HowGiftWorks from './_components/HowGiftWorks';
import Research from './_components/Research';
import WhoGiftsFor from './_components/WhoGiftsFor';

const Content = () => {
  return (
    <>
      <GiftHero />
      <HowGiftWorks />
      <WhoGiftsFor position="top" />
      <GiftTestimonials />
      <InverseHeader enter>
        <ProductBreakthrough shopButton />
      </InverseHeader>
      <WhoGiftsFor position="bottom" />
      <GiftMarquee />
      <GiftCallToAction />
      <Research />
    </>
  );
};

export default Content;
